import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(list)/sales-orders',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/orders/sales-orders' ||
      location.pathname === '/orders/sales-orders/'
    ) {
      throw redirect({
        to: '/orders/sales-orders/active',
        search: { aiSummaryId: undefined, aiOrderNumber: undefined },
      });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/SalesOrdersLayout'),
    'SalesOrdersLayout',
  ),
});
